import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ContentTemplate, TitleHeader } from 'web-library';
import ExamReceipt from '../../modules/examRegistration/components/ExamReceipt';
import ResitReceipt from '../../modules/resit/components/@candidate/ResitReceipt';
import RouteKey from '../../routes/key';
import AmendmentReceipt from '../../modules/subject/components/AmendmentReceipt';
import CoordinatorAppealReceiptAndPaymentLink from '../appeal/CoordinatorAppealReceiptAndPaymentLink';
import SchoolCandidatePaymentReceipt from '../../modules/payment/components/SchoolCandidatePayment/SchoolCandidatePaymentReceipt';

interface ExamRegistrationType {
  examRegistrationType: string;
}

const { summary } = RouteKey['payment-link'].child;
const { paymentLink } = RouteKey.child;

const Receipt = ({ isResitPaymentLink = false }: { isResitPaymentLink?: boolean }) => {
  const { t } = useTranslation();
  let title = t('resit->>ResitReceipt.Thank you. Your registration has been submitted.');
  const { examRegistrationType } = useParams<ExamRegistrationType>();

  const resitLabel = 'resit';
  const appealRegistrationLabel = 'appeal-registration';
  const examRegistrationLabel = 'exam-registration';
  const amendmentRegistrationLabel = 'amendment-registration';
  const schoolCandidatePaymentLabel = 'school-candidate-payment';

  if (
    examRegistrationType === 'exam-registration' ||
    examRegistrationType === schoolCandidatePaymentLabel
  ) {
    title = t('exam->>PaymentLink.ThankYouReceipt');
  }

  if (examRegistrationType === appealRegistrationLabel) {
    title = t('appeal->>AppealReceipt.SubmittedAppeal');
  }

  return (
    <>
      <TitleHeader state="success" title={title} largeContentContainer />

      {examRegistrationType === resitLabel && (
        <ContentTemplate>
          <ResitReceipt isPaymentLink={isResitPaymentLink} />
        </ContentTemplate>
      )}
      {examRegistrationType === appealRegistrationLabel && (
        <CoordinatorAppealReceiptAndPaymentLink isPaymentLink />
      )}
      {examRegistrationType === examRegistrationLabel && (
        <ContentTemplate>
          <ExamReceipt
            toSummaryLink={`/${paymentLink}/${examRegistrationType}/${summary}`}
            isPaymentLink
          />
        </ContentTemplate>
      )}

      {examRegistrationType === amendmentRegistrationLabel && (
        <ContentTemplate>
          <AmendmentReceipt isPaymentLink />
        </ContentTemplate>
      )}
      {examRegistrationType === schoolCandidatePaymentLabel && (
        <ContentTemplate>
          <SchoolCandidatePaymentReceipt />
        </ContentTemplate>
      )}
    </>
  );
};

export default Receipt;
